const Listing = ({ address = {}, photoUrl = '' } = {}) => {
  return {
    address: String(address.street || ''),
    photoUrl: String(photoUrl),
  };
};

export default Listing;
